import styled from 'styled-components';

export default styled.div`
  width: 10px;
  height: 10px;
  background: #00ffca;
  display: inline-block;
  border-radius: 5px;
  margin: 0 5px;
`;
